<template>
  <section class="alert alert-danger" v-if="errors && errors.length > 0">
    <button class="close" v-on:click="$emit('clear')"><span>&times;</span></button>
    <p v-if="errors.length === 1">
      <strong>Error: </strong> {{ errors[0] }}
    </p>
    <section v-else>
      <p>Errors:</p>
      <ul>
        <li v-for="error in errors">
          {{ error }}
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
export default {
  name: 'errors-alert',
  props: ['errors'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/errors-alert.vue